import React, { useRef, useEffect } from "react";
import { MathJax } from "better-react-mathjax";

type MountedMathJaxProps = {
  children: string;
};

export const MountedMathJax: React.FC<MountedMathJaxProps> = ({ children }) => {
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <MathJax
      dynamic
      onError={(err) => {
        if (!mounted.current) return;
        console.error("MathJax typesetting error:", err);
      }}>
      {children}
    </MathJax>
  );
};
